import React from 'react';
import styles from './Typography.module.scss';

export const UnderlinedText = ({ children }: {children: React.ReactNode}) => {
	return (
		<span className={styles.UnderlinedText}>{children}</span>
	);
};
